// extracted by mini-css-extract-plugin
module.exports = {"root":"TwoColumnTemplate_root__RZ5vD","right":"TwoColumnTemplate_right__TwUwK","main":"TwoColumnTemplate_main__Ybbye"};